export const UserRoleType = {
  admin: 'Admin'
}